import React from 'react';
import { ExternalLayout } from 'src/components/ExternalLayout/ExternalLayout';
import { Container } from '@components/common/Container';
import { Banner } from './Banner';
import { HowItWorks } from './HowItWorks';
import { ShareExperience } from './ShareExperience';
import { Benefits } from './Benefits';
// import { TrustedBy } from './TrustedBy';
import { StartChecking } from './StartChecking';
import Pledge2Pay from '../Pledge2Pay/Pledge2Pay';

export const Home = () => {
  return (
    <ExternalLayout>
      <Container>
        <Banner />
      </Container>
      <Container>
        <HowItWorks />
      </Container>
      <ShareExperience />
      <Container>
        <Benefits />
      </Container>
      <Container>
        {/* <TrustedBy /> */}
        <StartChecking />
      </Container>
      <Container style={{ margin: '1%' }}>
        <Pledge2Pay />
      </Container>
    </ExternalLayout>
  );
};
